<template>
  <header class="bg-white shadow-sm">
    <div class="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
      <!-- Mobile View -->
    <div v-if="isMobile()" class="flex flex-col space-y-4">
      <div class="flex items-center justify-between w-full">
        <img src="../assets/apitu_logo.jpg" alt="" style="width: 80px; margin-left:20px;">
        <div class="flex items-center space-x-3">
          <button
            @click="$emit('toggle-cart')"
            class="relative p-2 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
          >
            <img class="cart-img" src="../assets/cart.png" />
            <span v-if="cartItemCount > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {{ cartItemCount }}
            </span>
          </button>
          <button
            v-if="isLoggedIn"
            @click="goToHistory"
            class="p-2 text-gray-900 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
          <button 
            v-if="isLoggedIn && userDetail" 
            @click="goToProfile"
            class="w-10 h-10 rounded-full overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <img 
              v-if="userDetail.image" 
              :src="getImageUrl(userDetail.image)"
              alt="Profile" 
              class="w-full h-full object-cover"
            >
            <div v-else class="w-full h-full bg-gray-300"></div>
          </button>
          <button
            @click="$emit('login')"
            class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {{ isLoggedIn ? 'Logout' : 'Login' }}
          </button>
          </div>
        </div>
        <div class="flex flex-row space-x-2 w-full">
          <!-- Search Input -->
          <div class="relative w-full">
            <input
              type="text"
              placeholder="Cari AC, nama penjual, atau alamat..."
              v-model="searchQuery"
              @input="handleSearch"
              class="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        
          <!-- Sort Dropdown -->
          <div class="w-1/3">
            <select
              v-model="sortBy"
              @change="$emit('sort', sortBy)"
              class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="name">Name</option>
              <option value="price">Price</option>
            </select>
          </div>
        </div>
        
      </div>

      <!-- Desktop View -->
      <div v-else class="flex items-center ">
        <img src="../assets/apitu_logo.jpg" alt="" style="width: 100px; margin-left:60px;">
        <div class="flex items-center space-x-4">
          <div class="relative">
            <input
              type="text"
              placeholder="Cari AC, nama penjual, atau alamat..."
              v-model="searchQuery"
              @input="handleSearch"
              class="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              style="width: 39rem; margin-left:3rem;"
            />
          </div>
          <select
            v-model="sortBy"
            @change="$emit('sort', sortBy)"
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="name">Name</option>
            <option value="price">Price</option>
          </select>
          <button
            @click="$emit('toggle-cart')"
            class="cart-button relative p-2 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
          >
            <img class="cart-img" src="../assets/cart.png" />
            <span v-if="cartItemCount > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {{ cartItemCount }}
            </span>
          </button>
          <button
            v-if="isLoggedIn"
            @click="goToHistory"
            class="p-2 text-gray-900 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        <button 
          v-if="isLoggedIn && userDetail" 
          @click="goToProfile"
          class="w-10 h-10 rounded-full overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <img 
            v-if="userDetail.image" 
            :src="getImageUrl(userDetail.image)"
            alt="Profile" 
            class="w-full h-full object-cover"
          >
          <div v-else class="w-full h-full bg-gray-300"></div>
        </button>
      <button
        @click="$emit('login')"
        class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {{ isLoggedIn ? 'Logout' : 'Login' }}
      </button>
    </div>
  </div>
  </div>
</header>
</template>

<script>
import { authService } from '../services/api';

export default {
  name: "HeaderComponent",
  props: {
    cartItemCount: {
      type: Number,
      default: 0,
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: "",
      sortBy: "name",
      includeSellerName: true,
      includeSellerAddress: true,
      userDetail: null
    };
  },
  methods: {
    isMobile() {
      return screen.width <= 760;
    },
    handleSearch() {
      this.$emit('search', {
        query: this.searchQuery,
        includeSellerName: this.includeSellerName,
        includeSellerAddress: this.includeSellerAddress
      });
    },
    goToProfile() {
      this.$router.push('/profil-info');
    },
    goToHistory() {
      this.$router.push({ 
        path: '/profil-info', 
        query: { tab: 'history' } 
      });
    },
    async fetchUserDetail() {
      try {
        if (this.isLoggedIn) {
          const response = await authService.getUserDetail();
          this.userDetail = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching user detail:', error);
      }
    },
    getImageUrl(imagePath) {
      return `https://be.ajakstore.com/storage/${imagePath}`;
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchUserDetail();
        } else {
          this.userDetail = null;
        }
      }
    }
  },
  emits: ["toggle-cart", "search", "sort", "login"],
};
</script>

<style>
.cart-img {
  width: 25px;
}
.cart-button {
  display: flex;
}
</style>
